export default __webpack_public_path__ + "static/media/croc@3x.0519ea10.png";